module.exports = __webpack_public_path__ + "static/media/mcgovern-medical-school-logo-uth.84bdf63a.svg";